import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { PoweredBy } from "@/components/PoweredBy";
import { ArrowLeft, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Card = ({ label, value, tone }) => <div className="bg-white rounded-xl border border-slate-200 px-4 py-3"><p className={`text-2xl font-bold ${tone || "text-navy-900"}`}>{value ?? 0}</p><p className="text-xs text-slate-500">{label}</p></div>;

export default function CabinDashboard() {
  const navigate = useNavigate();
  const token = localStorage.getItem("sf_cabin_token");
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!token) { navigate("/login"); return; }
    axios.get(`${API}/public/cabin/my/dashboard`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setD(r.data)).catch(() => setD({ visitors: {}, tickets: {}, meetings: {}, activity: [] }));
  }, []);
  if (!d) return <div className="min-h-screen flex items-center justify-center bg-slate-100"><Loader2 className="animate-spin text-navy-900" /></div>;

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-navy-900 px-5 py-4"><button onClick={() => navigate("/cabin-portal")} className="text-blue-100/80 hover:text-white flex items-center gap-1.5 text-sm"><ArrowLeft size={16} /> Portal</button></header>
      <main className="max-w-2xl mx-auto px-4 py-6">
        <h1 className="font-display text-xl font-bold text-navy-900 mb-4">Dashboard</h1>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">Visitors</p>
        <div className="grid grid-cols-2 gap-3 mb-5"><Card label="Pending Approvals" value={d.visitors.pending} tone="text-amber-600" /><Card label="Today's Visitors" value={d.visitors.today} /></div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">Meetings</p>
        <div className="grid grid-cols-2 gap-3 mb-5"><Card label="Upcoming Bookings" value={d.meetings.upcoming} tone="text-blue-600" /><div /></div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">Service Requests</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6"><Card label="Open" value={d.tickets.open} tone="text-blue-600" /><Card label="In Progress" value={d.tickets.in_progress} tone="text-amber-600" /><Card label="Resolved" value={d.tickets.resolved} tone="text-emerald-600" /><Card label="Overdue" value={d.tickets.overdue} tone="text-rose-600" /></div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">Recent Activity</p>
        <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100">
          {(d.activity || []).length === 0 ? <p className="p-4 text-sm text-slate-500">No recent activity.</p> : d.activity.map((a, i) => (
            <div key={i} className="px-4 py-3 flex items-center justify-between" data-testid={`activity-${i}`}><span className="text-sm text-navy-900">{a.text}</span><span className="text-xs text-slate-400">{a.ts ? new Date(a.ts).toLocaleDateString() : ""}</span></div>
          ))}
        </div>
        <div className="mt-8 flex justify-center"><PoweredBy /></div>
      </main>
    </div>
  );
}
